import { getLayerProps } from '@/utils/layer-kit';
import { LayerType, MaterialIdsType, type IMediaInfo, type IMediaLayerProps } from '@/version-types';

/**
 * 获取空图层数据
 */
export function getEmptyMediaLayerProps() {
    return getLayerProps({
        layerType: LayerType.MEDIA_LAYER,
        data: {
            url: '',
            naturalWidth: 800,
            naturalHeight: 800,
            mediaType: '',
            autoplay: true,
            loop: true,
            controls: true,
            imageTransform: {
                offsetX: 0,
                offsetY: 0,
                rotate: 0,
                scale: 1,
                flipH: false,
                flipV: false,
                widthRatio: 1,
                heightRatio: 1,
            },
        },
    });
}

/**
 * 获取矢量图层数据
 *
 * @param props - 图层属性
 * @param info - 媒体信息
 */
export function getMediaLayerProps(
    {
        url,
        width,
        height,
        left,
        top,
        materialId,
    }: {
        url: string;
        width: number;
        height: number;
        left?: number;
        top?: number;
        materialId?: string;
    },
    info: IMediaInfo,
) {
    const layer = getEmptyMediaLayerProps();
    if (left) {
        layer.left = left;
    }
    if (top) {
        layer.top = top;
    }
    layer.width = width;
    layer.height = height;
    if (materialId) {
        layer.materialIds = layer.materialIds || {};
        layer.materialIds[MaterialIdsType.MEDIA] = [materialId];
    }
    (layer.data as IMediaLayerProps).url = url;
    layer.data = { ...(layer.data as IMediaLayerProps), ...info };
    return layer;
}
